jQuery(document).ready(function($){
  $(".btn-video").modalVideo({channel:'vimeo'});
  
  var lastScrollTop = 0;
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
     if (st > lastScrollTop){
         $('#shopify-section-header').addClass('scrolling_down');
         $('#shopify-section-header').removeClass('scrolling_up');
     } else {
         $('#shopify-section-header').addClass('scrolling_up');
         $('#shopify-section-header').removeClass('scrolling_down');
     }
     lastScrollTop = st;
  });
  $('.search_block_item .text-md.capitalize.cursor-pointert').click(function(e){
    	e.preventDefault();
      	var ele = $(this).closest('#Search').find('.Search__Input');
        ele.val($(this).text());
      //$(this).closest('#Search').find('.Search__Form').submit();
  });
  
  
  if($('.ratting-list').length > 0) {
    $('.ratting-list').owlCarousel({
      loop:false,
      margin:0,
      nav:true,
      responsiveClass:true,
      items:3,
      mouseDrag:true,
      touchDrag:true,
      pullDrag:false,
      freeDrag:false,
      responsive:{
        0:{
          items:1,
          loop:true,
          mouseDrag:true
        },
        480:{
          items:2,
          loop:true,
          mouseDrag:true
        },
        641:{
          items:3,
          touchDrag:false,
          mouseDrag:false
        }
      }
    })
  }
  if($('.app-store').length > 0) {
    $('.app-store').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      responsiveClass:true,
      items:3,
      mouseDrag:true,
      touchDrag:true,
      pullDrag:false,
      freeDrag:false,
      responsive:{
        0:{
          items:3,
          loop:true,
          mouseDrag:true
        },
        400:{
          items:3,
          loop:true,
          mouseDrag:true
        },
        641:{
          items:3,
          touchDrag:false,
          mouseDrag:false,
          loop:false
        }
      }
    })
  }
  
  AOS.init();
  
})